import * as React from 'react'
// @ts-ignore
import { Button, List, Header } from 'relevant-ui'
import './styles.scss'
import { compose } from 'redux'
import { withTranslation } from 'react-i18next'
// @ts-ignore
import SEARCH from 'assets/search.svg'
import PageHeader from '@App/components/blocks/UiPage/Header'
import { connect } from 'react-redux'
import { toggleFieldAction } from '@App/store/toggleField'

class UiPage extends React.Component<any> {
  constructor(props: any) {
    super(props)
  }

  render() {
    const {
      title,
      data,
      withHeader,
      handleClick,
      handleSearch,
      children,
      toggleFieldAction,
      current,
      setCurrent,
      button,
      search,
    } = this.props

    return (
      <div className="ui">
        {withHeader && (
          <PageHeader
            button={button}
            search={search}
            onClick={handleClick}
            onChange={handleSearch || null}
          />
        )}
        <div className="uiWrapper">
          <div className="uiWrapper__list">
            <List
              title={title}
              data={data || []}
              onClick={(e) => {
                setCurrent(e)
                toggleFieldAction(true)
              }}
              isDisabled={current === null}
            />
          </div>
          <div className="uiWrapper__form">{children}</div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: any) => {
  const {
    applications: { current },
  } = state

  return {
    current,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    toggleFieldAction: (bool: boolean) => dispatch(toggleFieldAction(bool)),
  }
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(UiPage)
